import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import "@/App.css";
import "@/NewDesign.css";
import PricePage from "./components/PricePage";
import AdminPage from "./components/AdminPage";
import AlarmPage from "./components/AlarmPage";
import ControlPanel from "./components/ControlPanel";
import AccessGate from "./components/AccessGate";

const ProfilePage = () => {
  const { id } = useParams();
  return <AccessGate profile={id}><PricePage profile={id} /></AccessGate>;
};

const ProfileTvPage = () => {
  const { id } = useParams();
  return <AccessGate profile={id}><PricePage profile={id} tvMode={true} /></AccessGate>;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PricePage profile="default" />} />
        <Route path="/tv" element={<PricePage profile="default" tvMode={true} />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/alarm" element={<AlarmPage />} />
        <Route path="/profekrn" element={<ControlPanel />} />
        <Route path="/:id/tv" element={<ProfileTvPage />} />
        <Route path="/:id" element={<ProfilePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
